// ==================== 全景图加载器 ====================

import * as THREE from 'three';

export class PanoramaLoader {
  private textureLoader: THREE.TextureLoader;
  private cache: Map<string, THREE.Texture> = new Map();

  constructor() {
    this.textureLoader = new THREE.TextureLoader();
  }

  /** 加载全景图并创建天空球 */
  async loadPanorama(imagePath: string): Promise<THREE.Mesh> {
    if (this.cache.has(imagePath)) {
      const tex = this.cache.get(imagePath)!;
      return this.createSkySphere(tex);
    }

    return new Promise((resolve, reject) => {
      this.textureLoader.load(
        imagePath,
        (texture) => {
          texture.colorSpace = THREE.SRGBColorSpace;
          this.cache.set(imagePath, texture);
          const sphere = this.createSkySphere(texture);
          resolve(sphere);
        },
        undefined,
        (err) => reject(new Error(`全景图加载失败: ${imagePath}`))
      );
    });
  }

  /** 创建天空球 */
  private createSkySphere(texture: THREE.Texture): THREE.Mesh {
    const geometry = new THREE.SphereGeometry(500, 60, 40);
    // 注意：不翻转几何体。side: BackSide 已让相机从球内看到内表面。
    // MeshBasicMaterial 不受光照影响，无需法线指向外侧。

    const material = new THREE.MeshBasicMaterial({
      map: texture,
      side: THREE.BackSide,
    });

    return new THREE.Mesh(geometry, material);
  }

  /** 创建占位全景球（无真实图片时使用） */
  createPlaceholderPanorama(): THREE.Mesh {
    const canvas = document.createElement('canvas');
    canvas.width = 2048;
    canvas.height = 1024;
    const ctx = canvas.getContext('2d')!;

    // 绘制渐变星空背景
    const gradient = ctx.createRadialGradient(1024, 512, 0, 1024, 512, 1200);
    gradient.addColorStop(0, '#0a0a2e');
    gradient.addColorStop(0.5, '#1a1a4e');
    gradient.addColorStop(1, '#000010');
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, 2048, 1024);

    // 绘制星星
    for (let i = 0; i < 300; i++) {
      const x = Math.random() * 2048;
      const y = Math.random() * 1024;
      const r = Math.random() * 1.5 + 0.3;
      const alpha = Math.random() * 0.8 + 0.2;
      ctx.beginPath();
      ctx.arc(x, y, r, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(255, 255, 255, ${alpha})`;
      ctx.fill();
    }

    const texture = new THREE.CanvasTexture(canvas);
    texture.colorSpace = THREE.SRGBColorSpace;
    return this.createSkySphere(texture);
  }

  dispose(): void {
    this.cache.forEach((tex) => tex.dispose());
    this.cache.clear();
  }
}
